import {useQuery} from 'react-query';

import getMyAdvertisements from '.';

interface IAdvertisementProps {
  filter: string;
}

const useGetMyAdverisements = (payload: IAdvertisementProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['my-ads', payload.filter],
    queryFn: () => getMyAdvertisements({filter: payload.filter}),
  });

  return {data, isLoading, refetch};
};

export default useGetMyAdverisements;
